import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/oj-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-acda9038"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "globalHeader" }
const _hoisted_2 = { class: "title-bar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "落畔题", -1))
const _hoisted_5 = ["src"]

import { useRouter } from "vue-router";
import { computed, ref, watchEffect } from "vue";
import { useStore } from "vuex";
import routes from "@/router/routes";
import checkAccess from "@/access/CheckAccess";
import AccessEnum from "@/access/AccessEnum";
import message from "@arco-design/web-vue/es/message";
import { LoginUserVO } from "../../generated/models/LoginUserVO";
import { UserControllerService } from "../../generated/services/UserControllerService";


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {

const store = useStore();
const loginUser = ref<LoginUserVO>();
watchEffect(() => {
  loginUser.value = store.state.user?.loginUser;
});
const router = useRouter();

// 需要展示的路由
const visibleRoutes = computed(() => {
  return routes.filter((item, index) => {
    if (item.meta?.hideInMenu) {
      return false;
    }
    // 根据权限过滤菜单
    return checkAccess(store.state.user.loginUser, item.meta?.access as string);
  });
});
//默认主页
const selectedKeys = ref(["/"]);
// 操作改变url
const doMenuClick = (key: string) => {
  router.push({
    path: key,
  });
};
// url改变页面
router.afterEach((to, from, failure) => {
  selectedKeys.value = [to.path];
});

/*setTimeout(() => {
  store.dispatch("user/getLoginUser", {
    userName: "luoying",
    userRole: AccessEnum.ADMIN,
  });
}, 3000);*/
const logout = async () => {
  const res = await UserControllerService.userLogoutUsingPost();
  if (res.code === 0) {
    location.reload();
    message.success("退出成功");
  } else {
    message.error("退出失败，", res.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_IconUser = _resolveComponent("IconUser")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_icon_user = _resolveComponent("icon-user")!
  const _component_a_anchor_link = _resolveComponent("a-anchor-link")!
  const _component_a_doption = _resolveComponent("a-doption")!
  const _component_icon_poweroff = _resolveComponent("icon-poweroff")!
  const _component_icon_import = _resolveComponent("icon-import")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, {
      class: "grid-demo",
      align: "center",
      wrap: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { flex: "auto" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_menu, {
              mode: "horizontal",
              "selected-keys": selectedKeys.value,
              onMenuItemClick: doMenuClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item, {
                  key: "0",
                  style: {"padding":"0","marginright":"38px","background-color":"rgb(255,255,255,0)"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_a_link, {
                        hoverable: false,
                        href: "/"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_link, {
                        hoverable: false,
                        href: "/"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRoutes.value, (item) => {
                  return (_openBlock(), _createBlock(_component_a_menu_item, {
                    key: item.path
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["selected-keys"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { flex: "80px" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_dropdown, { trigger: "hover" }, {
              content: _withCtx(() => [
                (loginUser.value && loginUser.value.userRole != _unref(AccessEnum).NOT_LOGIN)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_a_doption, null, {
                        icon: _withCtx(() => [
                          _createVNode(_component_icon_user)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_anchor_link, { href: "/mine" }, {
                            default: _withCtx(() => [
                              _createTextVNode("个人信息")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_doption, null, {
                        icon: _withCtx(() => [
                          _createVNode(_component_icon_poweroff)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_anchor_link, { onClick: logout }, {
                            default: _withCtx(() => [
                              _createTextVNode("退出登录")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_a_doption, null, {
                        icon: _withCtx(() => [
                          _createVNode(_component_icon_import)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_anchor_link, { href: "/user/login" }, {
                            default: _withCtx(() => [
                              _createTextVNode("登录")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_doption, null, {
                        icon: _withCtx(() => [
                          _createVNode(_component_icon_user)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_anchor_link, { href: "/user/register" }, {
                            default: _withCtx(() => [
                              _createTextVNode("注册")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 64))
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_avatar, {
                  shape: "circle",
                  class: "userAvatar"
                }, {
                  default: _withCtx(() => [
                    (loginUser.value && loginUser.value.userRole != _unref(AccessEnum).NOT_LOGIN)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (loginUser.value.userAvatar)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                alt: "avatar",
                                src: loginUser.value.userAvatar,
                                style: {"border-radius":"50%"}
                              }, null, 8, _hoisted_5))
                            : (_openBlock(), _createBlock(_component_a_avatar, { key: 1 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_IconUser)
                                ]),
                                _: 1
                              }))
                        ], 64))
                      : (_openBlock(), _createBlock(_component_a_avatar, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode("未登录")
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})